import { hasAccessToFlutterDRS } from "../../../utils/feature_mapping";
import { getFlutterDashboardClass, isMobileDevice } from "../../../utils/web-helper";

import React from "react";

const PageHead = (props) =>{
      const flutterDashboardClass = isMobileDevice() && hasAccessToFlutterDRS() ? ` ${getFlutterDashboardClass()}` : '';

    return <div className={`page-head ${flutterDashboardClass}`}>
        {props.children}
    </div>
}

export default PageHead;